import React from 'react';

export default function SalaryRevision() {
  return (
    <div>salaryRevision</div>
  );
}
